<template>
  <div class="container-fluid">
    <div class="row">
      <div class="d-none d-md-block col-3 pt-5 register-banner">
        <div class="text-md-center mt-5 text-white" style="font-size: 24px">
          Comienza a <b>practicar</b> tus <b>habilidades</b> en
          <b>matemáticas</b> ahora
        </div>
      </div>

      <div class="col p-4">
        <p class="text-black-50 text-right">
          ¿Ya tienes cuenta?
          <router-link to="/v2/auth/login" class="text-dark">Ingresa</router-link>
        </p>

        <div
          v-if="!postPassword"
          class="text-center py-4"
          style="max-width: 376px; margin: auto"
        >
          <MobiusLogo to="/home" />

          <h1 class="text-dark font-h3 mt-5">Cambia tu contraseña</h1>

          <span class="d-block text-center mt-4 mb-3 text-black-50">
            Ingresa los datos a continuación.
          </span>

          <!-- Login form -->
          <form>
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input type="password" v-model="passwordInfo.password" id="password" class="form-control"/>
              <small v-if="formErrorMessage.password" class="error-hint">
                {{ formErrorMessage.password }}
              </small>
              <small v-if="formErrorMessage.passwordValidation" class="error-hint">
                {{ formErrorMessage.passwordValidation }}
              </small>
            </div>
            <div class="form-group">
              <label for="passwordRepeat">Repita la Contraseña</label>
              <input type="password" v-model="passwordInfo.passwordRepeat" id="passwordRepeat" class="form-control"/>
              <small v-if="formErrorMessage.passwordRepeat" class="error-hint">
                {{ formErrorMessage.passwordRepeat }}
              </small>
            </div>
            <button class="btn btn-primary w-100" @click.prevent="changePassword()">
              Cambiar Contraseña
            </button>
          </form>
          <!-- End Login form -->
        </div>

        <div
          v-else
          class="m-auto mt-4 p-4 text-center"
          style="max-width: 500px"
        >
          <IconifyIcon :icon="icons.bxEnvelope" height="32" />
          <h2 class="h4 mt-4">
            La contraseña fue cambiada correctamente.
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IconifyIcon from "@iconify/vue";
import bxEnvelope from "@iconify/icons-bx/bx-envelope";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "ChangePassword",
  components: { IconifyIcon, MobiusLogo },
  data() {
    return {
      passwordInfo: {
        password: "",
        passwordRepeat: "",
        recoverToken: ""
      },
      formErrorMessage: {
        password: null,
        passwordRepeat: null,
        passwordValidation: null
      },
      postPassword: false,
      icons: {
        bxEnvelope,
      },
    };
  },
  methods: {
    validateRecoverPassword() {
      let loader = this.$loading.show({});
      axios
        .get(
          `${import.meta.env.VITE_API_BASE_URL}/auth/validate-recover-password/${this.$route.params.token}`
        )
        .then(() => {
          loader.hide();
        }).catch((error) => {
          console.log(error);
          loader.hide();
          this.goToLogin();
          this.$toasted.error("Token Inválido, no es posible cambiar la contraseña.", {position: 'top-center', duration: 3000});
        });
    },
    changePassword() {
      if (this.validateChangePassword()) {
        this.passwordInfo.recoverToken = this.$route.params.token;
        let loader = this.$loading.show({});
        axios
          .post(
            `${import.meta.env.VITE_API_BASE_URL}/auth/change-password`, this.passwordInfo
          )
          .then(() => {
            loader.hide();
            this.postPassword = true;
          })
          .catch((error) => {
            console.log(error);
            loader.hide();
            this.$toasted.error("No fue posible cambiar la contraseña.", {position: 'top-center', duration: 3000});
          });
      }
    },
    validateChangePassword() {
      let errorCount = 0;
      if (!this.passwordInfo.password) {
        this.formErrorMessage.password = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.password = null;
      }
      if (!this.passwordInfo.passwordRepeat) {
        this.formErrorMessage.passwordRepeat = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.passwordRepeat = null;
      }
      if (this.passwordInfo.passwordRepeat && this.passwordInfo.password &&
          this.passwordInfo.password !== this.passwordInfo.passwordRepeat) {
        this.formErrorMessage.passwordValidation = "Las contraseñas no coinciden.";
        errorCount++;
      } else {
        this.formErrorMessage.passwordValidation = null;
      }

      return errorCount === 0;
    },

    goToLogin() {
      // Redirect to login
      this.$router.push("/v2/auth/login");
    },
  },
  mounted() {
    this.validateRecoverPassword();
  },
};
</script>

<style scoped>
.register-banner {
  background-image: url("../assets/images/register-banner.jpg");
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  max-width: 430px;
}
</style>
